export default __webpack_public_path__ + "static/media/hair.a4b056a6.png";